import { db } from "../../firebase";

import { addDoc, collection } from "firebase/firestore";

import HelperForMetaData from "../../helpers/HelperForMetaData";

export const CreateBusinessRecord = async (local, generic) => {
  const { profile } = generic;
  const record = {
    businessName: local.business || profile.name || "",
    uid: local.uid,
    ...HelperForMetaData({}),
  };

  const clientsCollection = await collection(db, "clients");
  return await addDoc(clientsCollection, record)
    .then((res) => true)
    .catch((err) => false);
};
